module.exports = __webpack_public_path__ + "static/media/404-bg-desktop.25293323.jpg";